import { useAuth } from '@/contexts'
import { MeetingType } from '@namuho/types'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

export const useFirstDate = () => {
    const baseUrl = `${import.meta.env.VITE_API_URL}/users/`

    const { getAccessToken, user } = useAuth()
    const consumeFirstDate = useMutation({
        mutationKey: [user?.id],
        mutationFn: async (meetingType: MeetingType) => {
            const body = {
                meetingType,
            }
            const response = await fetch(`${baseUrl}${user?.id}/firstDate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: (await getAccessToken()) || '',
                },
                body: JSON.stringify(body),
            })
            return response.json()
        },
        onSuccess: (data) => {
            if (data.code === 'OK') {
                toast.success('Erste Date/Treffen Gratis eingelöst')
            }
        },
        onError: () => {
            toast.error('Etwas ist schiefgelaufen')
        },
    })

    return {
        consumeFirstDate: consumeFirstDate.mutateAsync,
        isLoading: consumeFirstDate.isLoading,
    }
}
